import { Col, Row } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AppContext from "../../../context/app/context";
import Form from "../../form-components/from";
import { INITIAL_PAGE } from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";
import EndPoints from "../../../services/end-points";
import ComplaintContext from "../../../context/complaint/context";
import { getComplaintStatus, getComplaintType } from "../../../models/complaint/enum";
import { useLocation } from "react-router-dom";
import { addSearchToURL, filtersToQueryString, getFiltersFromURL, getKeywordFromURL } from "../../../utils/helpers/url";

interface IProps { }

const ComplaintFilter: React.FC<IProps> = () => {
  const { t } = useTranslation();
  const { actions, query } = useContext(ComplaintContext);

  const [clients, setClients] = useState<any[]>([]);
  const [ClientLoading, setClientLoading] = useState<boolean>(false);
  const { direction } = useContext(AppContext);

  const types = [1, 2, 3]
  const status = [1, 2, 3]
  const location = useLocation();
  const [initialValues, setInitialValues] = useState<Record<string, any>>({});

  useEffect(() => {
    const filters = getFiltersFromURL();

    const initialValuesObj = {};
    filters.forEach((f) => {
      initialValuesObj[f.name] = f.value;
    });

    setInitialValues(initialValuesObj);
  }, [location.search]); useEffect(() => {
    const getClient = async () => {
      try {
        const { data } = await EndPoints.client.getAllClient({
          light: true,
          perPage: -1,
        });
        setClients(data.data);
        setClientLoading(false);
      } catch (error) {
      } finally {
        setClientLoading(false);
      }
    };
    getClient();
  }, [direction]);
  return (
    <Form
      formId="complaint-filter"
      defaultValues={initialValues}
      onSubmit={(data) => {
        const keyword = getKeywordFromURL();
        const filter: any = {
          page: INITIAL_PAGE,
          perPage: query?.perPage,
          keyword: keyword,
          filters: [
            data?.clientId
              ? {
                name: "clientId",
                value: data.clientId,
                operation: "eq",
              }
              : undefined,
            data?.type
              ? {
                name: "type",
                value: data.type,
                operation: "eq",
              }
              : undefined,
            data?.status
              ? {
                name: "status",
                value: data.status,
                operation: "eq",
              }
              : undefined,
          ].filter((f) => f),
        };
        const queryString = filtersToQueryString(filter.filters);
        window.history.replaceState(null, "", `?${queryString}`);
        addSearchToURL(keyword);
        actions.setQuery(filter);
      }}
    >
      <Row justify={"start"} gutter={[10, 0]}>
        <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="clientId"
            label={`${t("client")}`}
            width="large"
            input={{
              type: "select",
              allowSearch: true,
              options: clients.map((client, index) => {
                return {
                  label: client?.firstName,
                  value: client.id as number,
                };
              }),
            }}
          />
        </Col>
        <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="type"
            label={`${t("type")}`}
            width="large"
            input={{
              type: "select",
              options: types?.map((type, index) => {
                return {
                  key: index,
                  label: t(getComplaintType(type)),
                  value: type,
                };
              }),
            }}
          />
        </Col>
        <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="status"
            label={`${t("status")}`}
            width="large"
            input={{
              type: "select",
              options: status.map((statu, index) => {
                return {
                  label: t(getComplaintStatus(statu)),
                  value: statu as number,
                };
              }),
            }}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default ComplaintFilter;
